// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBEm-PximNY1iEZEEQurBhnx1TpVUBHUV8",
  authDomain: "codecanvas-11309.firebaseapp.com",
  projectId: "codecanvas-11309",
  storageBucket: "codecanvas-11309.firebasestorage.app",
  messagingSenderId: "507207980165",
  appId: "1:507207980165:web:15b4f604d46ddcbd82c5ec",
  measurementId: "G-N8Y1331CQB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics (only in production)
let analytics;
if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
  analytics = getAnalytics(app);
}

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Connect to emulators in development (uncomment if you want to use local emulators)
// if (process.env.NODE_ENV === 'development') {
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, 'localhost', 8080);
// }

export default app;
